<div class="staffmember">
  @if (selectedStaff?.photo) {
    <div class="image" [style.background-image]="'url('+selectedStaff?.photo+')'">
    </div>
  }
  @if (!selectedStaff?.photo) {
    <div class="image">
      <mat-icon class="material-symbols-outlined person-icon">
        person
      </mat-icon>
    </div>
  }
  <div class="name mt-3">
    <strong>{{ selectedStaff?.firstname }} {{ selectedStaff?.lastname }}</strong>
  </div>
  <div class="reg">
    {{ selectedStaff?.profReg ? selectedStaff?.profReg : "" }}
  </div>
</div>
